"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RpcQueue = /*#__PURE__*/function () {
  function RpcQueue(api) {
    var requestLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

    _classCallCheck(this, RpcQueue);

    this.api = api;
    this.requestLimit = requestLimit;
    this.elements = [];
    this.interval = null;
    this.preloadedCollections = {};
  }

  _createClass(RpcQueue, [{
    key: "fetchAsset",
    value: function () {
      var _fetchAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(owner, assetID) {
        var _this = this;

        var useCache,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                useCache = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
                _context.next = 3;
                return this.fetch_single_row('assets', owner, assetID, function (data) {
                  return useCache || typeof data !== 'undefined' ? _this.api.cache.getAsset(assetID, data) : null;
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchAsset(_x, _x2) {
        return _fetchAsset.apply(this, arguments);
      }

      return fetchAsset;
    }()
  }, {
    key: "fetchAccountAssets",
    value: function () {
      var _fetchAccountAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(account) {
        var _this2 = this;

        var rows;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetch_all_rows('assets', account, 'asset_id');

              case 2:
                rows = _context2.sent;
                return _context2.abrupt("return", rows.map(function (asset) {
                  return _this2.api.cache.getAsset(asset.asset_id, asset);
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchAccountAssets(_x3) {
        return _fetchAccountAssets.apply(this, arguments);
      }

      return fetchAccountAssets;
    }()
  }, {
    key: "fetchTemplate",
    value: function () {
      var _fetchTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(collectionName, templateID) {
        var _this3 = this;

        var useCache,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                useCache = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
                _context3.next = 3;
                return this.fetch_single_row('templates', collectionName, templateID, function (data) {
                  return useCache || typeof data !== 'undefined' ? _this3.api.cache.getTemplate(collectionName, templateID, data) : null;
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchTemplate(_x4, _x5) {
        return _fetchTemplate.apply(this, arguments);
      }

      return fetchTemplate;
    }()
  }, {
    key: "fetchSchema",
    value: function () {
      var _fetchSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(collectionName, schemaName) {
        var _this4 = this;

        var useCache,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                useCache = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : true;
                _context4.next = 3;
                return this.fetch_single_row('schemas', collectionName, schemaName, function (data) {
                  return useCache || typeof data !== 'undefined' ? _this4.api.cache.getSchema(collectionName, schemaName, data) : null;
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchSchema(_x6, _x7) {
        return _fetchSchema.apply(this, arguments);
      }

      return fetchSchema;
    }()
  }, {
    key: "fetchCollection",
    value: function () {
      var _fetchCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(collectionName) {
        var _this5 = this;

        var useCache,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                useCache = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
                _context5.next = 3;
                return this.fetch_single_row('collections', this.api.contract, collectionName, function (data) {
                  return useCache || typeof data !== 'undefined' ? _this5.api.cache.getCollection(collectionName, data) : null;
                });

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchCollection(_x8) {
        return _fetchCollection.apply(this, arguments);
      }

      return fetchCollection;
    }()
  }, {
    key: "fetchCollectionSchemas",
    value: function () {
      var _fetchCollectionSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(collectionName) {
        var _this6 = this;

        var rows;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.fetch_all_rows('schemas', collectionName, 'schema_name');

              case 2:
                rows = _context6.sent;
                return _context6.abrupt("return", rows.map(function (schema) {
                  return _this6.api.cache.getSchema(collectionName, schema.schema_name, schema);
                }));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchCollectionSchemas(_x9) {
        return _fetchCollectionSchemas.apply(this, arguments);
      }

      return fetchCollectionSchemas;
    }()
  }, {
    key: "fetchCollectionTemplates",
    value: function () {
      var _fetchCollectionTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(collectionName) {
        var _this7 = this;

        var rows;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.fetch_all_rows('templates', collectionName, 'template_id');

              case 2:
                rows = _context7.sent;
                return _context7.abrupt("return", rows.map(function (template) {
                  return _this7.api.cache.getTemplate(collectionName, String(template.template_id), template);
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchCollectionTemplates(_x10) {
        return _fetchCollectionTemplates.apply(this, arguments);
      }

      return fetchCollectionTemplates;
    }()
  }, {
    key: "preloadCollection",
    value: function () {
      var _preloadCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(collectionName) {
        var useCache,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                useCache = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : true;

                if (!(!useCache || !this.preloadedCollections[collectionName] || this.preloadedCollections[collectionName] + 15 * 60 * 1000 < Date.now())) {
                  _context8.next = 6;
                  break;
                }

                _context8.next = 4;
                return this.fetchCollectionSchemas(collectionName);

              case 4:
                _context8.next = 6;
                return this.fetchCollectionTemplates(collectionName);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function preloadCollection(_x11) {
        return _preloadCollection.apply(this, arguments);
      }

      return preloadCollection;
    }()
  }, {
    key: "fetchOffer",
    value: function () {
      var _fetchOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(offerID) {
        var _this8 = this;

        var useCache,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                useCache = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : true;
                _context9.next = 3;
                return this.fetch_single_row('offers', this.api.contract, offerID, function (data) {
                  return useCache || typeof data !== 'undefined' ? _this8.api.cache.getOffer(offerID, data) : null;
                });

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function fetchOffer(_x12) {
        return _fetchOffer.apply(this, arguments);
      }

      return fetchOffer;
    }()
  }, {
    key: "fetchAccountOffers",
    value: function () {
      var _fetchAccountOffers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(account) {
        var _this9 = this;

        var rows, offers;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Promise.all([this.fetch_all_rows('offers', this.api.contract, 'offer_sender', account, account, 2, 'name'), this.fetch_all_rows('offers', this.api.contract, 'offer_recipient', account, account, 3, 'name')]);

              case 2:
                rows = _context10.sent;
                offers = rows[0].concat(rows[1]);
                return _context10.abrupt("return", offers.map(function (offer) {
                  return _this9.api.cache.getOffer(offer.offer_id, offer);
                }));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchAccountOffers(_x13) {
        return _fetchAccountOffers.apply(this, arguments);
      }

      return fetchAccountOffers;
    }()
  }, {
    key: "dequeue",
    value: function dequeue() {
      var _this10 = this;

      if (this.interval) {
        return;
      }

      this.interval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (_this10.elements.length > 0) {
                  _this10.elements.shift()();
                } else {
                  clearInterval(_this10.interval);
                  _this10.interval = null;
                }

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      })), Math.ceil(1000 / this.requestLimit));
    }
  }, {
    key: "fetch_single_row",
    value: function () {
      var _fetch_single_row = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(table, scope, match, cacheFn) {
        var _this11 = this;

        var indexPosition,
            keyType,
            _args13 = arguments;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                indexPosition = _args13.length > 4 && _args13[4] !== undefined ? _args13[4] : 1;
                keyType = _args13.length > 5 && _args13[5] !== undefined ? _args13[5] : '';
                return _context13.abrupt("return", new Promise(function (resolve, reject) {
                  var data = cacheFn();

                  if (data !== null) {
                    return resolve(data);
                  }

                  _this11.elements.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                    var options, resp;
                    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            data = cacheFn();

                            if (!(data !== null)) {
                              _context12.next = 3;
                              break;
                            }

                            return _context12.abrupt("return", resolve(data));

                          case 3:
                            _context12.prev = 3;
                            options = {
                              code: _this11.api.contract,
                              table: table,
                              scope: scope,
                              limit: 1,
                              lower_bound: match,
                              upper_bound: match,
                              index_position: indexPosition,
                              key_type: keyType
                            };
                            _context12.next = 7;
                            return _this11.api.getTableRows(options);

                          case 7:
                            resp = _context12.sent;

                            if (!(resp.rows.length === 0)) {
                              _context12.next = 10;
                              break;
                            }

                            return _context12.abrupt("return", reject(new Error('Row not found for ' + JSON.stringify(options))));

                          case 10:
                            return _context12.abrupt("return", resolve(cacheFn(resp.rows[0])));

                          case 13:
                            _context12.prev = 13;
                            _context12.t0 = _context12["catch"](3);
                            return _context12.abrupt("return", reject(_context12.t0));

                          case 16:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, null, [[3, 13]]);
                  })));

                  _this11.dequeue();
                }));

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function fetch_single_row(_x14, _x15, _x16, _x17) {
        return _fetch_single_row.apply(this, arguments);
      }

      return fetch_single_row;
    }()
  }, {
    key: "fetch_all_rows",
    value: function () {
      var _fetch_all_rows = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(table, scope, tableKey) {
        var _this12 = this;

        var lowerBound,
            upperBound,
            indexPosition,
            keyType,
            _args17 = arguments;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                lowerBound = _args17.length > 3 && _args17[3] !== undefined ? _args17[3] : '';
                upperBound = _args17.length > 4 && _args17[4] !== undefined ? _args17[4] : '';
                indexPosition = _args17.length > 5 && _args17[5] !== undefined ? _args17[5] : 1;
                keyType = _args17.length > 6 && _args17[6] !== undefined ? _args17[6] : '';
                return _context17.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(resolve, reject) {
                    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            _this12.elements.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                              var resp;
                              return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                                while (1) {
                                  switch (_context15.prev = _context15.next) {
                                    case 0:
                                      _context15.next = 2;
                                      return _this12.api.getTableRows({
                                        code: _this12.api.contract,
                                        scope: scope,
                                        table: table,
                                        lower_bound: lowerBound,
                                        upper_bound: upperBound,
                                        limit: 1000,
                                        index_position: indexPosition,
                                        key_type: keyType
                                      });

                                    case 2:
                                      resp = _context15.sent;

                                      if (resp.more && indexPosition === 1) {
                                        _this12.elements.unshift( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                                          var next;
                                          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                                            while (1) {
                                              switch (_context14.prev = _context14.next) {
                                                case 0:
                                                  _context14.prev = 0;
                                                  _context14.next = 3;
                                                  return _this12.fetch_all_rows(table, scope, tableKey, resp.rows[resp.rows.length - 1][tableKey], upperBound, indexPosition, keyType);

                                                case 3:
                                                  next = _context14.sent;

                                                  if (next.length > 0) {
                                                    next.shift();
                                                  }

                                                  resolve(resp.rows.concat(next));
                                                  _context14.next = 11;
                                                  break;

                                                case 8:
                                                  _context14.prev = 8;
                                                  _context14.t0 = _context14["catch"](0);
                                                  reject(_context14.t0);

                                                case 11:
                                                case "end":
                                                  return _context14.stop();
                                              }
                                            }
                                          }, _callee14, null, [[0, 8]]);
                                        })));

                                        _this12.dequeue();
                                      } else {
                                        resolve(resp.rows);
                                      }

                                    case 4:
                                    case "end":
                                      return _context15.stop();
                                  }
                                }
                              }, _callee15);
                            })));

                            _this12.dequeue();

                          case 2:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16);
                  }));

                  return function (_x21, _x22) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function fetch_all_rows(_x18, _x19, _x20) {
        return _fetch_all_rows.apply(this, arguments);
      }

      return fetch_all_rows;
    }()
  }]);

  return RpcQueue;
}();

exports.default = RpcQueue;